"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BasisTheoryApplications = void 0;

var _common = require("./../common");

var _service = require("./../service");

var _CrudBuilder = require("./../service/CrudBuilder");

const BasisTheoryApplications = new _CrudBuilder.CrudBuilder(class BasisTheoryApplications extends _service.BasisTheoryService {
  /**
   * @deprecated use {@link retrieveByKey} instead
   */
  getApplicationByKey() {
    return this.retrieveByKey();
  }

  retrieveByKey(options) {
    return this.client.get('/key', (0, _common.createRequestConfig)(options)).then(_common.dataExtractor);
  }
  /**
   * @deprecated This method is deprecated. Use Terraform or https://portal.basistheory.com to manage keys instead.
   */


  regenerateKey(id, options) {
    return this.client.post(`${id}/regenerate`, undefined, (0, _common.createRequestConfig)(options)).then(_common.dataExtractor);
  }

}).create().retrieve().update().delete().list().build();
exports.BasisTheoryApplications = BasisTheoryApplications;